import { render, staticRenderFns } from "./ModalReject.vue?vue&type=template&id=d5d86fd4&scoped=true"
import script from "./ModalReject.vue?vue&type=script&lang=js"
export * from "./ModalReject.vue?vue&type=script&lang=js"
import style0 from "./ModalReject.vue?vue&type=style&index=0&id=d5d86fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d86fd4",
  null
  
)

export default component.exports